import { LanguagesEnum } from '@shared-app/lib/types';
export const languages = [
    { code: LanguagesEnum.EN, label: 'English' },
    { code: LanguagesEnum.DE, label: 'Deutsch' }
];
